"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
let TableTrialSamplesTracking = class TableTrialSamplesTracking extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.isCheckedGlobal = false;
        this.checkContainer = [];
        this.checkContainerCodes = [];
        this.samplesConstructor = [];
        this.sample = '';
        this.arrayCodesMultySelects = [];
        this.codesSelectedsCopys = [];
        this.isCheck = false;
        this.arrMultiCopy = [];
        this.labPhases = [
            'Lab received',
            'Lab dna extraction',
            'Lab pcr',
            'Lab pool',
            'Lab sequenced',
            'Lab quality control',
        ];
        this.norepeat = [];
    }
    //  getData('text/plain')
    async multiCopy(sampleCode) {
        this.arrMultiCopy.push(sampleCode);
        let notRepeat = [];
        notRepeat = this.arrMultiCopy.filter((item, index) => {
            return this.arrMultiCopy.indexOf(item) === index;
        });
        notRepeat.push(' ');
        const stringCodes = notRepeat.toString();
        navigator.clipboard.writeText(stringCodes.trim());
        const t = await navigator.clipboard.readText();
    }
    async isMultiCopyFn() {
        const t = await navigator.clipboard.readText();
        if (t.split(',').length < this.arrMultiCopy.length) {
            this.arrMultiCopy = [];
        }
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
    }
    isSampleSelected(code) {
        return (this.isCheckedGlobal ||
            this.arrayCodesMultySelects.includes(code) ||
            this.checkContainer.includes(code));
    }
    changeIsSampleSelected(newValue, code) {
        this.pushFn(code);
        this.pushCodesSelectedsCopys(code);
    }
    pushCodesSelectedsCopys(code) {
        this.codesSelectedsCopys.push(code);
    }
    multipleSelect(sampleCode) {
        this.arrayCodesMultySelects = [];
        const pre = this.checkContainer[0];
        const last = sampleCode;
        const arrSamples = [];
        for (const sample of this.samples) {
            arrSamples.push(sample.sample_code);
        }
        const preIndex = arrSamples.indexOf(pre);
        const lastIndex = arrSamples.indexOf(last);
        if (lastIndex > preIndex) {
            this.arrayCodesMultySelects = arrSamples.slice(preIndex, lastIndex + 1);
            for (const code of this.arrayCodesMultySelects) {
                this.checkContainer.push(code);
            }
        }
        else {
            this.arrayCodesMultySelects = arrSamples.slice(lastIndex, preIndex + 1);
            for (const code of this.arrayCodesMultySelects) {
                this.checkContainer.push(code);
            }
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.$emit('codesSelect', notRepeat);
    }
    f() {
        if (this.isCheckedGlobal) {
            //this.isCheck = true;
            this.arrayCodesMultySelects = [];
            this.checkContainer = [];
            for (const sample of this.samples) {
                this.checkContainer.push(sample.sample_code);
            }
        }
        else {
            this.checkContainer = [];
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.$emit('codesSelect', notRepeat);
    }
    filterCheck() {
        if (this.ischeckActive) {
            this.isCheckedGlobal = true;
        }
        else {
            this.isCheckedGlobal = false;
        }
    }
    createConstructor() {
        const arr = [];
        for (const sample of this.samples) {
            arr.push({ code: '', location: '', time: '', treatment: '' });
        }
        this.samplesConstructor = arr;
    }
    pushFn(sampleCode) {
        //this.isCheck = !this.isCheck;
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
            this.checkContainer = [];
        }
        if (this.arrayCodesMultySelects.includes(sampleCode)) {
            this.arrayCodesMultySelects = this.checkContainer.filter((item) => item !== sampleCode);
        }
        if (this.checkContainer.includes(sampleCode)) {
            this.checkContainer = this.checkContainer.filter((item) => item !== sampleCode);
        }
        else {
            this.checkContainer.push(sampleCode);
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => this.checkContainer.indexOf(item) === index);
        this.norepeat = notRepeat;
        this.$emit('codesSelect', notRepeat);
    }
    isSampleCheckContainer(sample_i) {
        return this.checkContainerCodes.include(sample_i.code);
    }
    modelEmitLocations(value, sample_i) {
        this.samplesConstructor.find((sample) => {
            if (sample.code === sample_i.code) {
                sample.code = sample_i.code;
                sample.location = value;
            }
        });
        this.$emit('modelEmitLocations', value);
    }
    modelEmitTimes(value, sample_i) {
        this.samplesConstructor.find((sample) => {
            if (sample.code === sample_i.code) {
                sample.code = sample_i.code;
                sample.time = value;
            }
        });
        this.$emit('modelEmitTimes', value);
    }
    modelEmitTreatments(value, sample_i) {
        this.samplesConstructor.find((sample) => {
            if (sample.code === sample_i.code) {
                sample.code = sample_i.code;
                sample.treatment = value;
            }
        });
        this.$emit('modelEmitTreatments', value);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableTrialSamplesTracking.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableTrialSamplesTracking.prototype, "locations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableTrialSamplesTracking.prototype, "times", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableTrialSamplesTracking.prototype, "treatment", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableTrialSamplesTracking.prototype, "isTableSubState", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableTrialSamplesTracking.prototype, "isSampleAction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableTrialSamplesTracking.prototype, "checkSample", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableTrialSamplesTracking.prototype, "pendingTag", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableTrialSamplesTracking.prototype, "ischeckActive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], TableTrialSamplesTracking.prototype, "state", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], TableTrialSamplesTracking.prototype, "globalState", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], TableTrialSamplesTracking.prototype, "f", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('ischeckActive')
], TableTrialSamplesTracking.prototype, "filterCheck", null);
TableTrialSamplesTracking = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            CheckBox: bmk_ui_framework_1.CheckBox,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableBody: bmk_ui_framework_1.TableBody,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            Select: bmk_ui_framework_1.Select,
            Tag: bmk_ui_framework_1.Tag,
            DateStylized: bmk_ui_framework_1.DateStylized,
            ProgressBarAlt: bmk_ui_framework_1.ProgressBarAlt,
            ProgressHeadingProposal: bmk_ui_framework_1.ProgressHeadingProposal,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            CheckAloneIcon: bmk_ui_framework_1.CheckAloneIcon,
            LoaderBuild: bmk_ui_framework_1.LoaderBuild,
            Dropdown: floating_vue_1.Dropdown,
            Toasts: bmk_ui_framework_1.Toasts,
            WarningSquaredIcon: bmk_ui_framework_1.WarningSquaredIcon,
        },
    })
], TableTrialSamplesTracking);
exports.default = TableTrialSamplesTracking;
